Apt.fn.make('home', {
	/**
	 * Initialize module
	 */
	init() {
		LS.common.setBasic(true);

		const scope = this;
		const $search = $$('homeSearch');
		const $form = $$('homeForm');

		scope.locator = Apt.fn.locator()
			.init('$homeLocator', {
				address: true,
				locate: true,
				preload: true,
				focused: () => {
					if ($.screen.size() < 3) {
						LS.util.crop();
					}

					$search[0].classList.add('-is-active');
				},
				collapse: () => {
					$search[0].classList.remove('-is-active');

					LS.util.uncrop();
				},
				changed: () => {
					$form.trigger('submit');
				}
			});

		$form.on('submit', () => {
			LS.header.search(scope.locator);
		}, {
			cancel: true,
			namespace: 'home'
		});

		LS.util.idle(() => {
			scope.features = Apt.fn.meta()
				.init('$homeFeatures');

			scope.territories = Apt.fn.meta()
				.init();

			scope.$private.initRelevant();

			scope.drag = [];

			LS.util.load('drag', () => {
				$$('overflowed').each(el => {
					const drag = Apt.fn.drag()
						.init(el);

					if (drag) {
						scope.drag.push(drag);
					}
				});
			});
		});
	},


	/**
	 * Unload module
	 */
	unload() {
		const scope = this;

		LS.util.reset('home', scope, [
			'features',
			'locator',
			'relevant',
			'territories'
		]);

		scope.drag.forEach(drag => {
			drag.$destroy();
		});

		LS.common.setBasic();
	}
}, {
	/**
	 * Initialize relevant properties
	 */
	initRelevant() {
		const scope = this;
		const $relevant = $$('homeRelevant');

		LS.util.scrolled($relevant, 'home', () => {
			scope.$public.relevant = Apt.fn['properties.relevant']()
				.init({
					context: $relevant,
					scroll: true,
					params: {
						near: LS.user.center(),
						limit: 6,
						featured: true,
						random: true,
						format: 'sale',
						size: {
							min: 5
						}
					}
				}, null);
			}, {
				margin: 480
			});
	}
});